export function getCompanyBrandClass(companyName = "") {
  const normalized = String(companyName).trim().toLowerCase();

  if (normalized === "guinot") {
    return "Guinot";
  }

  if (normalized === "mary cohr") {
    return "MaryCohr";
  }

  if (normalized === "guinot & mary cohr") {
    return "GMC";
  }

  return String(companyName).replace(/[^a-z0-9]+/gi, "");
}
